import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  RadioGroup,
  Radio,
  Stack,
  Text,
  Collapse,
  IconButton,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';

const SelectTagModal = ({
  isOpen,
  onClose,
  tags = [],
  onSelectTag,
  selectedTag,
  operand,
}) => {
  const [tempSelectedTag, setTempSelectedTag] = useState(selectedTag || '');
  const [expandedDevices, setExpandedDevices] = useState({});
  const [allowedTagTypes, setAllowedTagTypes] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setTempSelectedTag('');
      setExpandedDevices({});
    }
  }, [isOpen]);

  useEffect(() => {
    if (operand === '!=' || operand === '==') {
      setAllowedTagTypes([10]);
    } else {
      setAllowedTagTypes([
        1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19,
      ]);
    }
  }, [operand]);

  // Filter tags based on allowed types
  const filteredTags = tags.map(deviceGroup => ({
    ...deviceGroup,
    device: deviceGroup.device.map(device => ({
      ...device,
      tag: device.tag.filter(tag => allowedTagTypes.includes(tag.type)),
    })),
  }));

  // Filter tags based on allowed types (güvenli hale getirildi)
  // const filteredTags = tags.map(deviceGroup => ({
  //   ...deviceGroup,
  //   device:
  //     deviceGroup.device?.map(device => ({
  //       ...device,
  //       tag:
  //         device.tag?.filter(tag => allowedTagTypes.includes(tag.type)) || [],
  //     })) || [],
  // }));

  const handleSave = () => {
    if (tempSelectedTag) {
      onSelectTag(tempSelectedTag);
      onClose();
    }
  };

  const handleDeviceToggle = deviceId => {
    setExpandedDevices(prevState => ({
      ...prevState,
      [deviceId]: !prevState[deviceId],
    }));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Tag</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {filteredTags.map((deviceGroup, index) => (
            <Flex key={index} direction="column" mb={4}>
              {deviceGroup.device.map(device => (
                <div key={device.uuid}>
                  <Flex align="center">
                    <IconButton
                      size="xs"
                      icon={
                        expandedDevices[device.uuid] ? (
                          <ChevronDownIcon />
                        ) : (
                          <ChevronRightIcon />
                        )
                      }
                      onClick={() => handleDeviceToggle(device.uuid)}
                      variant="ghost"
                      aria-label="Expand/Collapse"
                    />
                    <Text fontWeight="bold" ml={2}>
                      {device.name}
                    </Text>
                  </Flex>
                  <Collapse in={expandedDevices[device.uuid]}>
                    <RadioGroup
                      onChange={setTempSelectedTag}
                      value={tempSelectedTag}
                    >
                      <Stack pl={6}>
                        {device.tag.map(tag => (
                          <Radio key={tag.id} value={tag.id}>
                            {tag.name}
                          </Radio>
                        ))}
                      </Stack>
                    </RadioGroup>
                  </Collapse>
                </div>
              ))}
            </Flex>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSave}
            isDisabled={!tempSelectedTag}
          >
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SelectTagModal;
